import { create } from 'zustand'

interface PublicProfileStore {
  activeTab: 'activity' | 'reviews' | 'transactions'
  setActiveTab: (tab: 'activity' | 'reviews' | 'transactions') => void
  isPublicProfile: boolean
  setIsPublicProfile: (isPublic: boolean) => void
  reset: () => void
}

export const usePublicProfileStore = create<PublicProfileStore>((set) => ({
  activeTab: 'activity',
  setActiveTab: (tab) => set({ activeTab: tab }),
  isPublicProfile: false,
  setIsPublicProfile: (isPublic) => set({ isPublicProfile: isPublic }),
  reset: () => set({ activeTab: 'activity', isPublicProfile: false }),
}))
